'use client';

import React from 'react';
import { cn, MilestoneProgressBar } from '@kidslabs/mario-nextjs-react-ui-core';
import { useGiftRuleThresholds } from '@kidslabs/module-flash-sale';
import type { GiftProgressBarProps } from './gift-progress-bar.types';
import styles from './gift-progress-bar.module.css';

/**
 * GiftProgressBar - Container component
 *
 * Fetches gift rule thresholds via useGiftRuleThresholds hook
 * and renders MilestoneProgressBar from UI Core.
 *
 * Container responsibilities: data fetching, loading/error states, data mapping
 * Presentation: delegated to MilestoneProgressBar (UI Core molecule)
 */
export const GiftProgressBar: React.FC<GiftProgressBarProps> = ({ isMobile }) => {
    const { milestones, grandTotal } = useGiftRuleThresholds();

    if (!Array.isArray(milestones) || milestones.length === 0) {
        return null;
    }

    return (
        <div className={cn(styles.container, isMobile && styles.containerMobile)}>
            <MilestoneProgressBar milestones={milestones} currentValue={grandTotal} testID="gift-progress-bar" />
        </div>
    );
};
